<template>
    <div>
        <el-row class="container p-24 p-lr-100" gutter="40">
            <el-col :span="6" class="card-desktop">
                <CardDesktop :ruleForm="ruleForm" :warning="1"></CardDesktop>
            </el-col>
            <el-col :span="18" class="card-content">
                <el-card style="border-radius: 16px" class="p-lr-40 p-b-20">
                    <p class="font-20 w-600 title">Bind Your Card</p>
                    <div class="text-center">
                        <qrcode-vue id="qrcode" class="m-t-50 m-b-20" :value="binkCardID" :size="250"></qrcode-vue>

                        <div class="store-icons mt-20">
                            <img class="m-r-20" src="@/assets/appStore.png" alt="" />
                            <img src="@/assets/googlePlay.png" alt="" />
                        </div>
                    </div>
                    <p class="font-20 w-600">Share Card</p>
                    <el-input v-model="link" disabled>
                        <template #prefix>
                            <el-icon color="#0E0111" size="20"><Link /></el-icon>
                        </template>
                        <template #suffix>
                            <span class="font-14 w-700" style="color: #b120b2; cursor: pointer" @click="copyLink">Copy</span>
                        </template>
                    </el-input>
                    <el-input placeholder="Show QR Code to Share" disabled class="m-t-10 qr-code-input">
                        <template #prefix>
                            <qrcode-vue :value="link" :size="50" class="m-r-10"></qrcode-vue>
                            <qrcode-vue style="display: none" id="qrsharecode" :value="link" :size="250"></qrcode-vue>
                        </template>
                        <template #suffix>
                            <span class="font-14 w-700" style="color: #b120b2; cursor: pointer" @click="downloadQRCode">Download</span>
                        </template>
                    </el-input>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script setup>
import QrcodeVue from 'qrcode.vue';
import { ref } from 'vue';
import CardDesktop from '@/components/cardDesktop.vue';
import { getCardById, keyConnectCreateQRUri } from '@/api/card.js';
import { ElMessage, ElLoading } from 'element-plus';
import { urlEncode } from '@/utils/util';
ElLoading.service();

const ruleForm = ref({});
const cardId = localStorage.getItem('cardId'); // Retrieve the card ID from localStorage
// card分享
const binkCardID = ref(null);
binkCardID.value =
    'keypear://keyconnect/saveContact?extraData=' +
    btoa(
        JSON.stringify({
            id: cardId,
            r: '/pages/myCard/createDemoCard'
        })
    );
// 联系人分享
// const shareCardId = ref(null);
// shareCardId.value =
//     'keypear://keyconnect/saveContact?extraData=' +
//     btoa(
//         JSON.stringify({
//             id: cardId,
//             cardType: 'KeyConnect_BusinessCard',
//             r: '/pages/Contacts/saveContact'
//         })
//     );

const link = ref(null); // Default link to be shared
getCardById(cardId).then(response => {
    ruleForm.value = response.data;
    ElLoading.service().close();
});

const copyLink = () => {
    navigator.clipboard
        .writeText(link.value)
        .then(() => {
            ElMessage.success('Link copied to clipboard!');

            // Optionally, you can show a success message to the user
        })
        .catch(err => {
            console.error('Failed to copy link: ', err);
            // Optionally, you can show an error message to the user
        });
};
keyConnectCreateQRUri({ id: cardId }).then(res => {
    if (res.code == 200) {
        link.value = `${process.env.VUE_APP_SHARE_URL}/#/pages/Share/index` + '?' + urlEncode({ uri: encodeURIComponent(res.data.uri), cardType: encodeURIComponent('KeyConnect_BusinessCard') });
    }
   
});

const downloadQRCode = () => {
    const qrcode = document.getElementById('qrsharecode');
    const imgurl = qrcode.toDataURL('image/png');
    const linkElement = document.createElement('a');
    linkElement.href = imgurl; // Path to the QR code image
    linkElement.download = 'qr-code.png'; // Name of the downloaded file
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
};
</script>
<style lang="scss" scoped>
.container {
    min-height: calc(100vh - 64px);
    background: #f3f4f6;

    .card-content {
        .title {
            padding: 20px 0;
            border-bottom: 1px solid #e2e2e2;
        }

        .qr-code {
            width: 250px;
            height: 250px;
            margin: 50px auto 20px;
        }

        .store-icons {
            img {
                cursor: pointer;
                width: 100px;
                height: 37px;
            }
        }

        ::v-deep .el-input.is-disabled .el-input__wrapper,
        ::v-deep .el-input.is-disabled .el-input__inner {
            background: transparent !important;
        }

        .qr-code-input {
            height: 80px !important;
        }
    }
}
</style>
